/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-array-index-key */
import type { BasketLineGroupViewModel } from 'autogen/swagger/all';
import { FromSupplier } from 'autogen/translation-keys/trans-website-checkout-summarybox-delivery';
import { Delivery } from 'autogen/translation-keys/trans-website-shared';
import Flex from 'components/Layout/components/Flex';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import { format } from 'modules/helpers/strings';
import BasketItem from 'components/basket/BasketItem/BasketItem';
import styled from 'styled-components';
import { ColorNordicGrey1 } from 'autogen/design-tokens/tokens';
import BasketSampleItem from 'components/basket/BasketItem/BasketSampleItem';
import BasketGiftItem from 'components/basket/BasketItem/BasketGiftItem';
import React from 'react';

function BasketGroupTitle({ basketGroup, deliveryNumber }) {
    const { t } = useTranslation();

    return (
        <Flex.Column gap="0">
            <Typography.Title size="S" as="span">
                {t(Delivery)} {deliveryNumber}
            </Typography.Title>
            <Typography.Body as="span" size="M">
                {format(t(FromSupplier))(basketGroup.supplierGroupName)}
            </Typography.Body>
        </Flex.Column>
    );
}

const Item = styled.div`
    padding-bottom: 16px;
    border-bottom: 1px solid ${ColorNordicGrey1};
`;

const List = styled(Flex.Column)`
    & ${Item}:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }
`;

export default function BasketGroupRenderer({ model: basketGroups }: { model: BasketLineGroupViewModel[] }) {
    return (
        <List>
            {basketGroups.map((basketGroup, index) => (
                <React.Fragment key={index}>
                    {basketGroups.length > 1 && (
                        <BasketGroupTitle basketGroup={basketGroup} deliveryNumber={index + 1} />
                    )}

                    {/* Normal Basket Item */}
                    {basketGroup.basketLines.map((basketLine, index) => (
                        <Item key={index}>
                            <BasketItem model={basketLine} />
                        </Item>
                    ))}

                    {/* Gift Basket Item */}
                    {basketGroup.giftLines.map((giftLine, index) => (
                        <Item key={index}>
                            <BasketGiftItem model={giftLine} />
                        </Item>
                    ))}

                    {/* Sample Basket Item */}
                    {basketGroup.sampleLines.map((sampleLine, index) => (
                        <Item key={index}>
                            <BasketSampleItem model={sampleLine} />
                        </Item>
                    ))}
                </React.Fragment>
            ))}
        </List>
    );
}
